import { useState, useEffect } from 'react';
import { AuthProvider } from 'react-oidc-context';
import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import axios from 'axios';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { getConfigsLogin } from '../axios/Login/loginApi';
import theme from '../assets/themes/theme';
import MaintenancePage from '../pages/ControlPanel/UserManagement/MaintenancePage';
import { SpinnerRing } from '../components/CustomSpinner';

export const KeycloakProvider = ({ children }) => {
  const [userManager, setUserManager] = useState(null);
  const [initFailed, setInitFailed] = useState(false);
  const url = window.location.origin + "/portal";

  useEffect(() => {
    const init = async () => {
      try {
        const { data } = await getConfigsLogin();

        const configObj = {
          authority: data.authority,
          client_id: data.client_id,
          automaticSilentRenew: true,
          redirect_uri: url,
          userStore: new WebStorageStateStore({
            store: window.localStorage,
          }),
        };

        const tokenEndpoint = url === 'http://localhost:3000/portal'
          ? 'http://localhost:8080/portal/api/biosense/v1/sso-login'
          : data.token_endpoint;

        const metadata = await getKeycloakConfiguration(data.authority);

        const finalConfig = {
          ...configObj,
          metadata: {
            ...metadata,
            token_endpoint: tokenEndpoint,
          },
          // automaticSilentRenew: false,
        };

        const manager = new UserManager(finalConfig);
        setUserManager(manager);
        setInitFailed(false);
      } catch (error) {
        console.error("Lỗi khởi tạo đăng nhập:", error);
        setInitFailed(true);
        window.dispatchEvent(new Event("MAINTENANCE_MODE"));
      }
    };

    init();
  }, []);

  if (userManager) {
    return <AuthProvider userManager={userManager}>{children}</AuthProvider>;
  }

  // Chỉ hiện trang lỗi khi init thất bại; login/logout bình thường → loading
  if (initFailed) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <MaintenancePage />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="min-h-screen flex items-center justify-center bg-white">
        <SpinnerRing loading size={50} color="#3B82F6" />
      </div>
    </ThemeProvider>
  );
};

export async function getKeycloakConfiguration(authority) {
  try {
    const { data } = await axios.get(
      `${authority}/.well-known/openid-configuration`,
      {
        headers: {
          Accept: "application/json",
        },
        withCredentials: false,
      }
    );
    console.log("getKeycloakConfiguration: ", data)
    return data;
  } catch (error) {
    console.error("Keycloak configuration fetch error:", error);
    return Promise.reject(error);
  }
}
